export default {
      id: "dots-usage",
      viewBox: "0 0 18 4",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#dots",
      toString: function () {
        return this.url;
      }
    }